// extracted by mini-css-extract-plugin
module.exports = {"home":"Home_home__2S7t_"};